import instance from '../xhrService';
import db from '../../db/db';
import { random } from 'lodash';

const baseUrl = '/api/positionables';
const url = (a, b, c, d) =>
  `${baseUrl}/${a}` +
  (b ? `/${b}` : '') +
  (c ? `/${c}` : '') +
  (d ? `/${d}` : '');

async function updateOffline(tType, id, data, online) {
  const pidArray = []

  for (let i = 0; i < data.length; i++) {
    const pId = data[i].id ? data[i].id : random(false, 1000000);

    const inspection = await db.inspections.get(data[i].start_inspection_id);

    if (!inspection) {
      return;
    }

    const syncObj = {
      synced: false,
      payload: [
        {
          method: 'update',
          target_id: id,
          tType: tType,
          ...data[i],
        },
      ],
    }

    if (online) {
      syncObj.synced = true;
      syncObj.payload = []
    }

    const positionableObj = {
      ...data[i],
      id: pId,
      tType: tType,
      project_id: inspection.project_id,
      target_id: Number(id),
      sync: {
        ...syncObj,
      },
    };

    if (data[i].id) {
      const existingPositionable = await db.positionables
        .get(pId)

      if (existingPositionable) {
        existingPositionable.sync.payload.push(
          positionableObj.sync.payload[0],
        );
        await db.positionables.update(pId, {
          ...positionableObj,
          sync: existingPositionable.sync,
        })
      }
      else {
        await db.positionables.put(positionableObj).catch((e) => {
          console.error('Error saving positionable to db', e);
        });
      }

    } else {
      await db.positionables.put(positionableObj).catch((e) => {
        console.error('Error saving positionable to db', e);
      });
    }
    pidArray.push(pId)
  }

  const positonables = await db.positionables
    .where('id')
    .anyOf(pidArray)
    .toArray();

  if (positonables.length === 0) {
    throw new Error('Positionable not found in offline db');
  }

  return positonables;
};

export const positionableApi = {
  index: async (tType, tId, iId, pType, pSubType = null) => {
    const params = {};
    if (pSubType) {
      params.type = pSubType;
    }

    if (navigator.onLine) {
      return instance
        .get(url(tType, tId, iId, pType), {
          params,
        })
        .then((response) => response.data);
    } else if (tType === 'project_inspection_uploads') {

      const inspection = await db.inspections.get(iId);

      return db.positionables
        .where('target_id')
        .equals(tId)
        .and((item) => item.positionable_type === 'findings')
        .and((item) => item.project_id === inspection.project_id)
        .and((item) => item.start_inspection_id <= iId)
        .toArray()
        .then((data) => {
          return data.map((item) => {
            return {
              ...item,
              positionable_type: pType,
            };
          });
        });
    } else {
      return Promise.reject(new Error('Offline mode not supported'));
    }
  },
  // update or insert en-masse
  bulkUpdate: async (tType, id, data) => {
    if (navigator.onLine) {



      const result = await instance
        .put(url(tType, id, 'update'), data)
        .then((response) => response.data);

      if (tType === 'project_inspection_uploads') {
        await updateOffline(tType, id, result, true);
      }

      return result;
    } else if (tType === 'project_inspection_uploads') {

      return await updateOffline(tType, id, data, false);


    } else {
      return Promise.reject(new Error('Offline mode not supported'));
    }
  },
  bulkDelete(positionableIds) {
    /** @todo refactor to single xhr */
    return Promise.all(
      positionableIds.map((id) => this.delete(id)),
    ).then(() => null);
  },
  delete: (id) => {
    const intId = parseInt(id);

    return instance.delete(url(intId)).then((response) => response);
  },
  editCreatedDate: (id, date) => {
    return instance
      .put(`${baseUrl}/${id}`, { updatedDate: date })
      .then((res) => res);
  },
  editRemovedOnDate: (id, date) => {
    return instance
      .put(`${baseUrl}/changeRemovedOnDate/${id}`, { updatedDate: date })
      .then((res) => res);
  },
  getPositionablesAuthor: (positionableId) => {
    return instance.get(`${baseUrl}/${positionableId}`).then((res) => res);
  },
};

export default positionableApi;
